var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.334473,
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1571 20.6993H25.8793L26.4637 16.895H22.1563V14.8158C22.1563 13.2355 22.6696 11.8341 24.1389 11.8341H26.5V8.51421C26.0852 8.45785 25.2078 8.33447 23.55 8.33447C20.0882 8.33447 18.0587 10.1738 18.0587 14.3642V16.895H14.5V20.6993H18.0587V31.1555C18.7634 31.2621 19.4773 31.3345 20.2101 31.3345C20.8724 31.3345 21.5189 31.2735 22.1571 31.1867V20.6993Z",
    fill: "#004B7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8b3de4768ed7576a8c18dc8f5715ebba.svg";
export { ForwardRef as ReactComponent };